import * as React from "react";
import PolicyList from "../List/PolicyList";
import { DataContext } from "../../App";
import { Button } from "@progress/kendo-react-buttons";
import { useHistory } from "react-router-dom";

export default function Policies() {
  const { context, setContext } = React.useContext(DataContext);
  const [oportunity, setOportunity] = React.useState(context.oportunity);
  const [policySelected, setPolicySelected] = React.useState(
    context.policy_selected || []
  );
  const history = useHistory();
  const [currentPath] = React.useState(
    history.location.pathname !== "/" ? history.location.pathname : ""
  );
  const setPolicysSelected = (policies) => {
    setPolicySelected(policies);
    setContext({ ...context, policy_selected: policies });
  };

  const setDetails = (policies) => {
    setPolicySelected(policies);
    setContext({ ...context, policy_detail: policies });
    history.push(currentPath + "/details" + context.urlSearch);
  };

  const toCompare = () => {
    if (policySelected.length > 0) {
      history.push(currentPath + "/comparative" + context.urlSearch);
    }
  };

  return (
    <div className="wrapper" id="ECommercePage">
      <PolicyList
        setPoliciesCompare={setPolicysSelected}
        setDetails={setDetails}
        data={oportunity}
        idOportunity={context.id_op}
        policySelectedContext={policySelected}
      />
      {/* <PolicyDetails
        setPoliciesCompare={setPolicysSelected}
        setDetails={setDetails}
        data={data}
      /> */}
      {context.policies.length > 0 ? (
        <div className="text-center assesor-contact-menu">
          <div className="assesor-contact-box">
            <a
              href={`https://wa.me/57${oportunity.broker?.mobile}`}
              className="asessor-whatsapp-menu"
              target="_blank"
              rel="noreferrer"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <i className="fa fa-whatsapp whatsapp-icon-menu"></i>
              </div>
            </a>
            {/* Ocultar botón de teléfono para Promotec: https://github.com/agentemotor/odoo-custom-addons/issues/1769 */}
            {!(
              oportunity?.tenant_data?.name === "promotec.co.agentemotor.com"
            ) && (
              <a
                href={`tel:+57${oportunity.broker?.mobile}`}
                className="asessor-phone-menu"
                target="_blank"
                rel="noreferrer"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <i className="fa fa-phone phone-icon-menu"></i>
                </div>
              </a>
            )}
            <Button
              className="btn-compare mt-2 mb-2 mx-auto sec-button nav-button"
              onClick={toCompare}
              style={{
                position: "static",
                margin: "0",
              }}
            >
              Comparar
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
